import type { IconProps } from '@carboncopyco/icons';
import { LockIcon } from '@carboncopyco/icons';
import type { WorkspaceType } from '@carboncopyco/types';
import type React from 'react';

export interface WorkspaceTypeIconProps {
  workspaceType: WorkspaceType;
  size?: string | number;
}

const iconByWorkspaceType: Partial<
  Record<WorkspaceType, React.FunctionComponent<IconProps>>
> = {
  private: LockIcon,
};

export const WorkspaceTypeIcon = ({
  workspaceType,
  size,
}: WorkspaceTypeIconProps) => {
  const Icon = iconByWorkspaceType[workspaceType];
  return Icon ? <Icon size={size ?? 24} /> : null;
};
